module.exports = function () {
    'use strict';
    function MediaElementPlayer(peaks, mediaElement) {
        var self = this;
        self._peaks = peaks;
        self._listeners = [];
        self._mediaElement = mediaElement;
    }
    MediaElementPlayer.prototype._addMediaListener = function (type, callback) {
        this._listeners.push({
            type: type,
            callback: callback
        });
        this._mediaElement.addEventListener(type, callback);
    };
    MediaElementPlayer.prototype.init = function (player) {
        var self = this;
        self._player = player;
        self._listeners = [];
        self._duration = self.getDuration();
        self._isPlaying = false;
        self._addMediaListener('timeupdate', function () {
            self._peaks.emit('player.timeupdate', self.getCurrentTime());
        });
        self._addMediaListener('playing', function () {
            self._isPlaying = true;
            self._peaks.emit('player.playing', self.getCurrentTime());
        });
        self._addMediaListener('pause', function () {
            self._isPlaying = false;
            self._peaks.emit('player.pause', self.getCurrentTime());
        });
        self._addMediaListener('ended', function () {
            self._peaks.emit('player.ended');
        });
        self._addMediaListener('seeked', function () {
            self._peaks.emit('player.seeked', self.getCurrentTime());
        });
        self._addMediaListener('canplay', function () {
            self._peaks.emit('player.canplay');
        });
        self._addMediaListener('error', function (event) {
            self._peaks.emit('player.error', event.target.error);
        });
        self._interval = null;
        if (self._mediaElement.readyState === HTMLMediaElement.HAVE_NOTHING) {
            self._mediaElement.load();
        }
    };
    MediaElementPlayer.prototype.destroy = function () {
        for (var i = 0; i < this._listeners.length; i++) {
            var listener = this._listeners[i];
            this._mediaElement.removeEventListener(listener.type, listener.callback);
        }
        this._listeners.length = 0;
        this._mediaElement = null;
    };
    MediaElementPlayer.prototype.play = function () {
        return this._mediaElement.play();
    };
    MediaElementPlayer.prototype.pause = function () {
        this._mediaElement.pause();
    };
    MediaElementPlayer.prototype.isPlaying = function () {
        return this._isPlaying;
    };
    MediaElementPlayer.prototype.isSeeking = function () {
        return this._mediaElement.seeking;
    };
    MediaElementPlayer.prototype.getCurrentTime = function () {
        return this._mediaElement.currentTime;
    };
    MediaElementPlayer.prototype.getDuration = function () {
        return this._mediaElement.duration;
    };
    MediaElementPlayer.prototype.seek = function (time) {
        this._mediaElement.currentTime = time;
    };
    return MediaElementPlayer;
}();